import * as angular from "angular";
import {IController} from "angular";

export class FulfillmentStepRelationsTableComponent implements IController {

  relations: any;
  step: any;

  constructor() {
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepRelationsTable', {
    bindings: {
      relations: '<',
      step: '<'
    },
    template: require('./fulfillment-step-relations-table.html').default,
    controller: FulfillmentStepRelationsTableComponent
  });
